import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { DoctorsService } from "../doctor-service/doctors.service";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { ConfirmationService } from "primeng/api";
import { DocLocalService } from "../doctor-service/doc-local.service";
import { take } from "rxjs/operators";

@Component({
  selector: "app-doctors",
  templateUrl: "./doctors.component.html",
  styleUrls: ["./doctors.component.css"],
  providers: [ConfirmationService],
})
export class DoctorsComponent implements OnInit {
  isData = false;
  searchQuery = null;
  token: string;
  docArray = [];
  filter;
  page = 1;
  totalItems = 0;
  config: { itemsPerPage: number; currentPage: number; totalItems: number };
  allTotal: number = 0;
  isSearch: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private docService: DoctorsService,
    private authService: AuthService,
    private conformationService: ConfirmationService,
    private dbLocalService: DocLocalService
  ) {}

  ngOnInit() {
    this.authService.authDataSubject.pipe(take(1)).subscribe((res) => {
      this.token = res._token;
    });
    this.getDoctorFromDb("1");
    this.initConfig();
    // this.docService.onpatApp().subscribe((res) => {
    //   console.log(res);
    // });
  }
  onAddDoctor() {
    this.router.navigate(["register"], {
      relativeTo: this.activatedRoute,
    });
  }
  onDoctorClicked(index) {
    this.router.navigate(["profile"], {
      relativeTo: this.activatedRoute,
      queryParams: { id: index },
    });
  }
  onUpdateDoctor(event, index) {
    event.stopPropagation();
    this.router.navigate(["register"], {
      relativeTo: this.activatedRoute,
      queryParams: { id: index },
    });
  }
  onDeleteDoctors(event, index, id) {
    this.conformationService.confirm({
      message: "Are you sure that you want to perform this action?",
      accept: () => {
        this.docService.onDelete(id, this.token).subscribe((res) => {
          this.docArray.splice(index, 1);
        });
        //Actual logic to perform a confirmation
      },
    });
    event.stopPropagation();
  }
  initConfig() {
    this.config = {
      itemsPerPage: 10,
      currentPage: this.page,
      totalItems: this.totalItems,
    };
  }
  pageChanged(event) {
    this.config.currentPage = event;
    if (this.isSearch && this.searchQuery) {
      this.searchDoctor(this.searchQuery, this.config.currentPage);
    } else {
      this.getDoctorFromDb(this.config.currentPage);
    }
  }
  getDoctorFromDb(page) {
    this.docService.getDoctorFromDb(this.token, page).subscribe((res) => {
      if (res.docData && res.docData.length > 0) {
        this.isData = true;
        this.docArray = res.docData;

        this.dbLocalService.saveDocArray(this.docArray);
        console.log(this.docArray);

        this.page = +res.page;
        this.totalItems = res.total;
        if (this.page === 1) {
          this.allTotal = res.total;
        }
        this.initConfig();
      }
    });
  }

  onSearchChange(value) {
    if (value) {
      this.searchDoctor(value, 1);
      this.isSearch = true;
      this.searchQuery = value;
    } else {
      this.docArray = this.dbLocalService.getDocArray();
      this.page = 1;
      this.isSearch = false;
      this.searchQuery = null;
      this.totalItems = this.allTotal;
      this.initConfig();
    }
  }
  searchDoctor(value, pageno) {
    this.docService
      .onSearchDoctor(value, this.token, pageno)
      .subscribe((res) => {
        this.isData = true;
        this.docArray = res.docData;
        console.log(this.docArray);
        this.page = res.page;
        this.totalItems = res.total;
        this.initConfig();
      });
  }
  onVerifyDoctor(event, index) {
    event.stopPropagation();
    this.docService.onverify(index, this.token).subscribe((res) => {
      this.getDoctorFromDb(this.config.currentPage);
    });
  }
  onUnVerifyDoctor(event, index) {
    event.stopPropagation();
    this.docService.onunverify(index, this.token).subscribe((res) => {
      this.getDoctorFromDb(this.config.currentPage);
    });
  }
}
